export default __webpack_public_path__ + "static/media/EXIT_BLOCK.a8cf9183.svg";